import Api from "~/service/Api";

class MediaItemSequenceRepository {
  update(tourId, data) {
    return Api.put(`/media-item/sequences/${tourId}`, data);
  }
}

export default MediaItemSequenceRepository;
